import type { RouteMiddleware, MiddlewareContext, RouteInfo } from '../types';
import { createDevLogRouter } from './router';

interface DevLogsMiddlewareOptions {
  logDir?: string; // log directory
  fileName?: string; // client.log by default
}

/**
 * Routes provided by dev logs middleware
 */
const DEV_LOGS_ROUTES: RouteInfo[] = [
  {
    method: 'POST',
    path: '/collect',
    description: 'Collect logs from client.',
  }
];

/**
 * Creates dev logs middleware for viewing application logs
 * Supports both rspack/webpack and Vite dev servers
 */
export function createCollectLogsMiddleware(options: DevLogsMiddlewareOptions = {}): RouteMiddleware {
  const { logDir } = options;

  return {
    name: 'collect-logs',
    mountPath: '/dev/logs',
    routes: DEV_LOGS_ROUTES,
    enabled: (context: MiddlewareContext) => context.isDev,
    createRouter: (context: MiddlewareContext) => {
      return createDevLogRouter({
        logDir: logDir || context.logDir,
        fileName: options.fileName || 'client.log',
      });
    },
  };
}
